import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import { qk } from '../keys';
import type { AnomaliesResult } from '../types';

/**
 * Аномалиите се смятат на сървъра при всяко четене. Менюто държи броя за
 * значката — затова опресняване на няколко минути, не на всеки екран.
 */
export function useAnomalies(includeAcked = false, enabled = true) {
  return useQuery({
    queryKey: qk.anomalies.list(includeAcked),
    queryFn: () => api.get<AnomaliesResult>('/anomalies', includeAcked ? { includeAcked: true } : {}),
    staleTime: 120_000,
    refetchInterval: 300_000,
    enabled,
  });
}

export function useAckAnomaly() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { key: string; note?: string }) => api.post<{ key: string }>('/anomalies/ack', input),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: qk.anomalies.all }),
  });
}

export function useUnackAnomaly() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => api.del<{ key: string }>(`/anomalies/ack/${encodeURIComponent(key)}`),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: qk.anomalies.all }),
  });
}
